type CsvResult = {
    file_name: string;
    lines: string[];
};
export function readCsvFile(file: File, limit: number): Promise<CsvResult> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            try {
                const text = event.target?.result as string;
                const rows = text
                .split("\n")
                .map(line => line.trim())
                .filter(Boolean)
                .slice(0, limit); 

                resolve({file_name: file.name, lines: rows});
            } catch (err) {
                reject(err);
            }
        };

        reader.onerror = () => reject(reader.error);
        reader.readAsText(file);
    });
}
